import { useEffect, useRef } from "react";

interface WebSocketProps {
    storeId: string;
    userId: string;
    token: string;
}

export const useMakeAgentOnline = ({ storeId, userId, token }: WebSocketProps) => {
    const wsRef = useRef<WebSocket | null>(null);

    useEffect(() => {
        if (!storeId || !userId || !token) return;

        const wsUrl = `wss://agentchatstage.goldeninfosystems.com/ws/agent-online/${storeId}/${userId}`;
        wsRef.current = new WebSocket(wsUrl, token); // Pass token in subprotocol

        wsRef.current.onopen = () => {
            console.log("WebSocket connected! Agent marked online.");
            wsRef.current?.send(JSON.stringify({ type: "ACTIVE" })); // Notify server
        };

        wsRef.current.onmessage = (event) => {
            console.log("Received:", event.data);
        };

        wsRef.current.onerror = (error) => {
            console.error("WebSocket error:", error);
        };

        wsRef.current.onclose = () => {
            console.log("WebSocket disconnected.");
        };

        return () => {
            wsRef.current?.close();
        };
    }, [storeId, userId, token]);

    return wsRef.current;
};
